import type { QueryClient } from '@tanstack/react-query';
import { clearWorklynxSessionPersistence } from '@/lib/sessionPersistence';
import { useAuthStore } from '@/stores/authStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { useOrgStore } from '@/stores/orgStore';

export function clearAuthenticatedClientState(queryClient?: QueryClient) {
  clearWorklynxSessionPersistence();
  useAuthStore.getState().clear();
  useOrgStore.getState().clear();
  useNotificationStore.getState().clear();
  queryClient?.clear();
}
